import { handleTrackClick } from "~/lib/analytics/handleTrackClick";

import styles from "./SubscribeLink.module.css";

export function SubscribeLink({
  position = "",
  href = "",
  onClick,
  className = "",
  children,
  ...attrs
}) {
  function handleClick(e) {
    if (position) handleTrackClick(position, e);
    onClick?.(e);
  }

  return (
    <a
      className={styles.subscribeLink}
      onClick={handleClick}
      href={href || "/getsciam/?utm_source=site&utm_medium=display&utm_term=homepage_button"}
      {...attrs}
    >
      {children || "Subscribe"}
    </a>
  );
}

export default SubscribeLink;
